var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "role"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('b', [_vm._v("  Edit Action pending By Operation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.Backinvestigation
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12 topButtons"
  }, [_c('b-button', {
    staticClass: "buttons",
    on: {
      "click": function($event) {
        _vm.goSummeryPage(_vm.awbnumber)
      }
    }
  }, [_vm._v("Shipment Summary")]), _vm._v(" "), (_vm.statuss == 20) ? _c('b-button', {
    on: {
      "click": function($event) {
        _vm.changeBucketModel()
      }
    }
  }, [_vm._v("Change Department")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" AWB Number :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "blue",
      "font-size": "13px"
    }
  }, [_vm._v("\n                  (Note: Use Comma(,) for Multiple AWB Numbers) ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "AWB",
      "name": "awbnumber",
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.awbnumber),
      callback: function($$v) {
        _vm.awbnumber = $$v
      },
      expression: "awbnumber"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "AWB"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('AWB')),
      expression: "errors.has('AWB')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("AWB Number is required. ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "name": "takeActionn",
      "label": "Take Action: <span style='color: red'>*</span> ",
      "label-cols": 2,
      "horizontal": true
    }
  }, [_c('div', {
    staticClass: "takeActionRadio"
  }, [(_vm.istakeaction == true) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("----------- Not Editable ----------- ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.takeactionlist), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "takeactionradiobtns",
      staticStyle: {
        "padding-right": "2.5%"
      },
      on: {
        "change": function($event) {
          _vm.selectData(n.id, n.label)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.takeActionname),
        expression: "takeActionname"
      }],
      attrs: {
        "type": "radio",
        "name": n.label
      },
      domProps: {
        "value": n.id,
        "checked": _vm._q(_vm.takeActionname, n.id)
      },
      on: {
        "__c": function($event) {
          _vm.takeActionname = n.id
        }
      }
    }), _vm._v("\n                  " + _vm._s(n.label) + "\n               ")])
  })], 2)])], 1)]), _vm._v(" "), (!_vm.blockVerifiedAsFlag) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Verified As :<span style='color: red'>*</span> ",
      "label-cols": 2,
      "horizontal": true
    }
  }, [_c('b-form-radio', {
    attrs: {
      "options": _vm.verifiedAs,
      "value": "1"
    },
    on: {
      "change": function($event) {
        _vm.selectData1($event)
      }
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.isDispute) ? _c('div', {
    staticClass: "form-group-row image-upload"
  }, [_c('label', {
    attrs: {
      "for": "upload"
    }
  }, [_vm._v("Upload images or videos")]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "note",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                      - Select multiple images by pressing Ctrl. "), _c('br'), _vm._v("\n                      - max 5 images are allowed. "), _c('br'), _vm._v("\n                      - max size for image: 2MB, video: 10MB"), _c('br')]), _vm._v(" "), _c('b-input-group', {
    staticClass: "imageUploadClass"
  }, [_c('input', {
    attrs: {
      "id": "upload",
      "type": "file",
      "options": _vm.verifiedAs,
      "multiple": "multiple"
    },
    on: {
      "change": function($event) {
        _vm.onImageFileChange($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imageGroup"
  }, _vm._l((_vm.images), function(image, index) {
    return _c('div', {
      key: index,
      staticClass: "image-view-upload row"
    }, [_c('img', {
      staticClass: "col-md-offset-1 col-md-2 col-sm-3 col-xs-4",
      attrs: {
        "src": image.url,
        "onerror": "this.src='static/img/vp.svg';"
      },
      on: {
        "click": function($event) {
          _vm.downloadImage(image)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.removeImage(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      staticStyle: {
        "font-size": "25px"
      }
    })])])
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.showupload && !_vm.isDispute) ? _c('div', {
    staticClass: "form-group image-upload row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Upload 3 Images :<span style='color: red'>*</span> ",
      "description": "Allowed image file types: gif, jpg, jpeg, png (Maximum Size :600 KB)",
      "label-cols": 3
    }
  }, [_c('b-input-group', [_c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('b-input-group-button', {
    slot: "right"
  }, [_c('b-button', {
    staticClass: "btn btn-sm btn-info",
    on: {
      "click": _vm.uploadFile
    }
  }, [_vm._v("Upload")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.imagesarr.length != 0) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("File Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("View Images")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.imagesarr), function(x, index) {
    return _c('tr', [_c('th', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(x.file))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "scope": "row"
      }
    }, [_c('b-link', {
      on: {
        "click": function($event) {
          _vm.downloadImage(x.imgPath)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('b-link', {
      attrs: {
        "href": x.imgPath
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('b-link', {
      on: {
        "click": function($event) {
          _vm.deleteImage(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])
  }))]) : _vm._e(), _c('br')], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.isDispute) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v("Images/Video uploaded by client:")]), _vm._v(" "), _vm._l((_vm.normalizedVideos), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "media-container"
    }, [_c('div', {
      staticClass: "image-container"
    }, [_vm._l((_vm.clientImages), function(img) {
      return [(img.attachment) ? [(_vm.isGoogleDriveLink(img.attachment)) ? _c('iframe', {
        staticClass: "media image-preview",
        attrs: {
          "src": _vm.convertToEmbedUrl(img.attachment),
          "frameborder": "0",
          "allowfullscreen": ""
        }
      }) : _c('img', {
        staticClass: "image-preview",
        attrs: {
          "src": img.attachment,
          "alt": "Image Preview",
          "onerror": "this.src='static/img/img-ph.png';"
        },
        on: {
          "click": function($event) {
            _vm.showMediaOfImage(img.attachment)
          }
        }
      })] : _vm._e()]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "video-container"
    }, _vm._l((item.videos), function(vid) {
      return _c('div', {
        key: vid.key,
        staticClass: "video-box"
      }, [(_vm.isGoogleDriveLink(vid.url)) ? _c('iframe', {
        staticClass: "media video-preview",
        attrs: {
          "src": _vm.convertToEmbedUrl(vid.url),
          "frameborder": "0",
          "allowfullscreen": ""
        }
      }) : _c('video', {
        staticClass: "video-preview",
        attrs: {
          "src": vid.url,
          "controls": ""
        }
      }, [_vm._v("\n                              Your browser does not support the video tag.\n                            ")]), _vm._v(" "), _c('p', {
        staticClass: "video-label"
      }, [_vm._v(_vm._s(vid.label))])])
    })), _vm._v(" "), _c('div', {
      staticClass: "download-button"
    }, _vm._l((item.videos), function(vid) {
      return _c('button', {
        key: vid.key + '_download',
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.downloadVideo(vid.url)
          }
        }
      }, [_vm._v("\n                            Download " + _vm._s(vid.label) + "\n                          ")])
    }))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.showBagCondition) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" STD Reason :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "STDreason",
      "options": _vm.STDreasonList,
      "placeholder": "Select",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.STDreason),
      callback: function($$v) {
        _vm.STDreason = $$v
      },
      expression: "STDreason"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('STDreason')),
      expression: "errors.has('STDreason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("STDreason is required. \n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.showLostReasonFlag) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Lost Reason :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "lostReason",
      "options": _vm.subReasonList,
      "placeholder": "Select",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.lostReason),
      callback: function($$v) {
        _vm.lostReason = $$v
      },
      expression: "lostReason"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('lostReason')),
      expression: "errors.has('lostReason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("lostReason is required. \n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.showBagCondition) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" DEPS Bag Condition :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-suitcase'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "bagCondition",
      "options": _vm.bagConditionList,
      "placeholder": "Select",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.bagCondition),
      callback: function($$v) {
        _vm.bagCondition = $$v
      },
      expression: "bagCondition"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bagCondition')),
      expression: "errors.has('bagCondition')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("bagCondition is required. \n                      ")])], 1) : _vm._e()]), _vm._v(" "), (_vm.isDispute) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.isAcceptanceDispute) ? _c('label', [_vm._v(" Acceptance Reason :")]) : _vm._e(), _vm._v(" "), (!_vm.isAcceptanceDispute) ? _c('label', [_vm._v(" Rejection Reason :")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-suitcase'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "disputeReason",
      "options": _vm.disputeReasonList,
      "placeholder": "Select",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.disputeReason),
      callback: function($$v) {
        _vm.disputeReason = $$v
      },
      expression: "disputeReason"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('disputeReason')),
      expression: "errors.has('disputeReason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("disputeReason is required. \n                      ")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Description :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "name": "description",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('description')),
      expression: "errors.has('description')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Description is required. \n                      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Save"), _c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_vm._v(" Reset "), _c('i', {
    staticClass: "fa fa-refresh"
  })])])])])])], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.takeActionloader,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF0000"
    }
  })], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "imgPopUp",
      "title": "BootstrapVue"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('b-card', {
    class: (_vm.Isvideo) ? 'card-body-width' : ''
  }, [_c('span', {
    staticClass: "download-btn"
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.imgData,
      "download": ""
    }
  }, [_vm._v("Download")])]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.closeImage()
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), (!_vm.Isvideo) ? _c('img', {
    attrs: {
      "src": _vm.imgData,
      "alt": "loading..."
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Isvideo) ? _c('video', {
    ref: "videoPlayer",
    attrs: {
      "controls": ""
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "changeBucket",
      "title": "BootstrapVue"
    },
    model: {
      value: (_vm.changeBucket),
      callback: function($$v) {
        _vm.changeBucket = $$v
      },
      expression: "changeBucket"
    }
  }, [_c('b-card', [_c('b-card-header', {
    staticClass: "p-1 header",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('span', [_vm._v("Change Department")])]), _vm._v(" "), _c('div', {
    staticClass: "popUpBucketChange"
  }, [_c('label', {
    attrs: {
      "for": "bucket"
    }
  }, [_vm._v("Select Bucket")]), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "hub",
      "options": _vm.bucketList,
      "placeholder": "Select Bucket",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.newBucket),
      callback: function($$v) {
        _vm.newBucket = $$v
      },
      expression: "newBucket"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Description :")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bucketChangeComment),
      expression: "bucketChangeComment"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.bucketChangeComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bucketChangeComment = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-button', {
    on: {
      "click": function($event) {
        _vm.changeBucketConfirm()
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-775c85ae","hasScoped":true}!./src/views/components/Edit/Edit.component.html
// module id = 655
// module chunks = 1